export const StatFilters = {
  LAST_12_MONTHS: 'last_12_months',
  LAST_12_WEEKS: 'last_12_weeks',
  ALL_TIME: 'all_time'
};

export const valueFromStatFilter = (filter) => {
  const lower = (filter || '').toLowerCase();
  switch (lower) {
    case StatFilters.LAST_12_MONTHS:
      return 52;
    case StatFilters.LAST_12_WEEKS:
      return 12;
    case StatFilters.ALL_TIME:
      return null;
    default:
      throw Error(`Invalid stats filter: ${filter}`);
  }
};
